


import { useEffect, useState } from "react";
import OrderCardsComp from "./OrderCardsComp";
import { getDashboardDetailsApi } from "../../helper/api_helper";
const DashboardComp = () => {
    const [isLoading, setIsLoading] = useState(false)
    const [dashboardDetails, setDashboardDetails] = useState()
    const getAdminDashboardDetails = async () => {
        try {
            setIsLoading(true)
            let response = await getDashboardDetailsApi()
            console.log("Response", response?.data);
            const dashData = response?.data
            console.log("DASHBOARD DATA ::",dashData);
            setDashboardDetails(dashData || [])
        } catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false)
        }
    }
    console.log("Dashboard Details ::", dashboardDetails);
    useEffect(() => {
        getAdminDashboardDetails()
    }, [])

    return (
            <div className='position-relative' style={{ minHeight: '300px' }}>
            {isLoading ? (
                <div className='d-flex justify-content-center align-items-center w-100 h-100 position-absolute top-0 start-0 bg-white bg-opacity-75'>
                    <div className='spinner-border' role='status' style={{ color : "black"}}>
                        <span className='visually-hidden'>Loading...</span>
                    </div>
                </div>
            ) : (
                <div className='row gy-4'>
                    <OrderCardsComp dashboardDetails={dashboardDetails} />
                </div>
            )}
        </div>
    );
};
export default DashboardComp;